var _circle, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2",
    "data-name": "Group 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 159.801,
    height: 162.232,
    viewBox: "0 0 159.801 162.232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 14.994,
    cy: 14.994,
    r: 14.994,
    transform: "translate(17.819 0)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M20.161,9.2,9.3,13.331c-8.949,4.5-.726,14.811,4.417,24.059l17.5,30.531a8.558,8.558,0,0,0,7.762,4.81l98.663.624a6.154,6.154,0,0,0,.278-12.294l-29.459-1.893-19.3-43.707a8.719,8.719,0,0,0-15.449-.957l-.4.678L58.223,40.362,45.685,17.8A19.635,19.635,0,0,0,20.161,9.2Zm73.424,49-21.84-1.4L81.63,38.008Z",
    transform: "translate(15.711 28.94)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M156.917,68.679H43.022L11.751,13.247a5.086,5.086,0,0,0-6.934-1.934h0a5.086,5.086,0,0,0-1.934,6.934h0L36.862,78.476v.048L19.018,114.19h11.33L48.063,78.862h68.655l18.2,35.606h11.4l-18.2-35.606h28.822a5.089,5.089,0,1,0,0-10.177Z",
    transform: "translate(-2.225 47.764)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.20fb7cec13f168bbcdf73ade5485bc32.svg";
export { ForwardRef as ReactComponent };